/* eslint-disable */
import React, { useEffect, useState } from "react";
import queryString from 'query-string';
import { 
    Card, CardBody, Col, Container, Row
  } from 'reactstrap';
import { Button, Spinner } from 'reactstrap';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { reduxForm } from "redux-form";
import { useForm } from "react-hook-form";
import { FormField, FormSelect } from "@/shared/components/FormField";
import ApiServices from "@/utils/ApiServices";
import { successMsg, globalError, formError, successMsgCustom } from "../../utils/message_herlper"
import TitleBreadCrumbs from '@/components/TitleBreadCrumbs'
import {  zipPattern } from '@/shared/helpers';

const CountyCreate = (props) => {
    const history = useHistory()
    let search = queryString.parse(props.location.search)  
    const { handleSubmit, reset, control, errors, register, setValue, clearErrors, formState } = useForm();
    const [isSubmit, setSubmit] = useState(false);
    const [type, setType] = useState(false);  
    const [noSubmit, setNoSubmit] = useState(0);  
    const [editData, setEditData] = useState(false);

    useEffect(() => {    
        setNoSubmit(formState?.submitCount || 0)
        if (formState.isSubmitted && Object.keys(formState?.errors).length > 0 && formState?.submitCount != noSubmit ) {
            formError()
            return
        }
    }, [formState])

    useEffect(() => {  
        let {type, id} =  props?.match?.params
        setType(type)
        if(type, id){  
            details(parseInt(id))
        }
    }, [location]);
    

     const details = (id) => {
        ApiServices.exemptionDetails(id).then((result) => {   
            let details = result?.data
            setEditData(details)
            setValue('title', details?.title)
        })
        .catch((error) => {
            formError();
        })
    }



    const onSubmit  = (form) => {
        setSubmit(true)
        if(type === 'create'){
            ApiServices.createExemption(form)
            .then((result) => { 
                successMsgCustom('New Exemption Type successfully added!') 
                setTimeout(() => {
                    history.push({pathname: `/exemption-type`});
                },1000)
            })
            .catch((error) => {
                setSubmit(false)
                if (error.response) {
                    formError(error?.response?.data?.errors)
                return
                }
                globalError()
            });
        }
        if(type === 'update'){
            form.id = editData?.id 
            ApiServices.updateExemption(form)
            .then((result) => {    console.log(result.data)
                successMsgCustom('Exemption Type successfully updated!') 
                setTimeout(() => {
                    history.push({pathname: `/exemption-type`});
                },1000)
            })
            .catch((error) => {
                setSubmit(false)
                if (error.response) {
                    console.log(error.response.data.errors)
                    // seErrors(error?.response?.data?.errors)
                    formError(error?.response?.data?.errors)
                return
                }
                globalError()
            });
        }
    }
    
    return (
        <Container>
            <TitleBreadCrumbs title={type === 'create' ? 'Create New County' : 'Edit County'} >
                <div className="page-breadcrumbs">
                    <Link to="/">Home</Link>
                    <Link to="/settings">Settings</Link>
                    <Link to="/exemption-type"> Exemption Type  List</Link>
                    <span className="current_breadcrumbs"> {type === 'create' ? 'Create' : 'Edit'}</span>
                </div>
            </TitleBreadCrumbs>
            <Row>
                <Col md={12}>
                    <Card className="card-controlled">
                        <CardBody className="cardbody-controlled">
                            <Row>
                                <Col md={12} className="edit-county-wrap">
                                    <form
                                        className="client-reg-form"
                                        onSubmit={handleSubmit(onSubmit)}
                                    >
                                        <div className="form__form-group">
                                            <span className="form__form-group-label">
                                               Title
                                            </span>
                                            <div className="form__form-group-field">
                                                <FormField
                                                    name="title"
                                                    component="input"
                                                    control={control}
                                                    errors={errors}
                                                    rules={{
                                                        required:
                                                            "This is required field",
                                                    }}
                                                    placeholder="Exemption Type Title"
                                                />
                                            </div>
                                            {errors?.title && (
                                                <span className="form__form-group-error">
                                                    {errors?.title?.message}
                                                </span>
                                            )}
                                        </div>
                                        <div className="edit-county-btns">
                                            <Link className="btn btn-secondary" to="/exemption-type">Back to List</Link>
                                            <Button
                                            className="float-right"
                                                type="submit"
                                                color="primary"
                                                disabled={isSubmit}
                                            > {isSubmit ? <Spinner size="sm" color="secondary" className="mr-2" /> : ''}
                                                {type === 'create' ? 'Submit' : ''}
                                                {type === 'update' ? 'Save Changes' : ''}
                                            </Button>
                                        </div>

                                    </form>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default reduxForm({
    form: 'create_county',
})(CountyCreate);